import { Typography } from "@mui/material";
import React from "react";
import { Box } from "@mui/material";
import { Link } from "@mui/material";
import { CheckoutMainCard } from "../Checkout_Dishes/CheckoutMainCard";
import CheckoutOderSummery from "../Checkout_Dishes/CheckoutOderSummery";

export default function OrderSummary({ setsubDetails, subDetails }) {
  console.log("subDetails", subDetails);
  return (
    <>
      <Box component="container">
        <Box
          sx={{
            // width: "745px",
            // width: "620px",
            width: "100%",
            height: "368.45px",
            border: "1px solid #E1E1E6",
            padding: "24px",
            borderRadius: "4px",
            overflowY: "scroll",
            // border: "1px solid green",
          }}
        >
          <Box>
            <Typography
              sx={{ fontSize: "24px", fontWeight: "600", marginBottom: "10px" }}
            >
              {" "}
              Order Summary
            </Typography>
          </Box>
          <Box
            sx={{
              // border: "1px solid red",
              width: {
                lg: "100%",
                md: "100%",
                sm: "100%",
                xs: "fit-content",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: "400",
                    color: "primary",
                    cursor: "pointer",
                  }}
                >
                  Menu
                </Typography>
              </Box>
              <Box>
                <Link>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "400",
                      color: "primary",
                      cursor: "pointer",
                    }}
                  >
                    Edit
                  </Typography>
                </Link>
              </Box>
            </Box>

            <Box
              sx={{
                width: {
                  lg: "100%",
                  md: "100%",
                  sm: "100%",
                  xs: "fit-content",
                },
                // border: "1px solid blue",
              }}
            >
              <CheckoutOderSummery
                setsubDetails={setsubDetails}
                subDetails={subDetails}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
